import * as React from 'react';

import { useViewport } from '@xyflow/react';

type HelperLinesProps = {
  horizontal: number | null;
  vertical: number | null;
};

export const HelperLines: React.FC<HelperLinesProps> = React.memo(
  ({ horizontal, vertical }) => {
    const viewport = useViewport();

    // Calculate line extent based on viewport
    // Lines should extend across visible area with some padding
    const padding = 1000; // Extra padding to ensure lines are visible
    const viewportLeft = -viewport.x / viewport.zoom - padding;
    const viewportRight =
      (-viewport.x + window.innerWidth) / viewport.zoom + padding;
    const viewportTop = -viewport.y / viewport.zoom - padding;
    const viewportBottom =
      (-viewport.y + window.innerHeight) / viewport.zoom + padding;

    // Don't render if no lines are active
    if (horizontal === null && vertical === null) {
      return null;
    }

    return (
      <svg
        className="pointer-events-none absolute inset-0 h-full w-full overflow-visible"
        style={{ zIndex: 10 }}
      >
        {horizontal !== null && (
          <line
            x1={viewportLeft}
            y1={horizontal}
            x2={viewportRight}
            y2={horizontal}
            stroke="#3b82f6"
            strokeWidth={1 / viewport.zoom}
            strokeDasharray={`${4 / viewport.zoom} ${4 / viewport.zoom}`}
            strokeOpacity={0.7}
          />
        )}
        {vertical !== null && (
          <line
            x1={vertical}
            y1={viewportTop}
            x2={vertical}
            y2={viewportBottom}
            stroke="#3b82f6"
            strokeWidth={1 / viewport.zoom}
            strokeDasharray={`${4 / viewport.zoom} ${4 / viewport.zoom}`}
            strokeOpacity={0.7}
          />
        )}
      </svg>
    );
  },
);

HelperLines.displayName = 'HelperLines';
